/* eslint-disable no-param-reassign */
import Vue from 'vue';
import uniqBy from 'lodash/uniqBy';
import groupBy from 'lodash/groupBy';
import omit from 'lodash/omit';

const mutations = {
  setChatUser(state, user) {
    state.chatUser = user;
    state.chatMode = 'chat';
  },
  backToChatList(state) {
    state.chatMode = 'list';
    state.chatUser = {};
  },
  setChatStatus(state, status) {
    state.chatStatus = status;
  },
  addContact(state, contact) {
    state.contacts = {
      ...state.contacts,
      [contact.userId]: contact,
    };
  },
  removeContact(state, userId) {
    state.contacts = omit(state.contacts, userId);
  },
  setChatChoices(state, choices) {
    state.chatChoices = choices;
  },
  setContacts(state, contacts) {
    const newContacts = {};
    contacts.forEach((c) => {
      newContacts[c.userId] = c;
    });
    state.contacts = newContacts;
  },
  addOnlineContacts(state, contacts) {
    state.onlineContacts = uniqBy([
      ...state.onlineContacts,
      ...contacts,
    ], 'userId');
  },
  removeOnlineContact(state, userId) {
    state.onlineContacts = state.onlineContacts.filter(c => c.userId !== userId);
  },
  addCurrencyExchangeRates(state, rates) {
    state.currencyExchangeRates = [
      ...state.currencyExchangeRates,
      ...rates,
    ];
  },
  setCent(state, cent) {
    state.cent = cent;
  },
  setRead(state, msg) {
    let user;
    if (msg.fromUserId === state.currentUser.userid) {
      user = msg.toUserId;
    } else if (msg.toUserId === state.currentUser.userid) {
      user = msg.fromUserId;
    }
    if (!state.msges[user]) return;
    const i = state.msges[user].findIndex(m => m.fromUserId === msg.fromUserId
      && m.toUserId === msg.toUserId && m.timestamp === msg.timestamp);
    if (i < 0) {
      return;
    }
    Vue.set(state.msges[user], i, msg);
  },
  setMsges(state, { userId, msges }) {
    Vue.set(state.msges, userId, msges);
    Vue.set(state.userChatLogPulled, userId, true);
  },
  setUnreadMsges(state, msges) {
    state.msges = groupBy(msges, (msg) => {
      if (msg.toUserId !== state.currentUser.userid) return msg.toUserId;
      if (msg.fromUserId !== state.currentUser.userid) return msg.fromUserId;
      return '';
    });
  },
  setChatActive(state, active) {
    state.chatActive = active;
  },
  addMsg(state, msg) {
    let user;
    if (msg.fromUserId === state.currentUser.userid) {
      user = msg.toUserId;
    } else if (msg.toUserId === state.currentUser.userid) {
      user = msg.fromUserId;
    }
    if (!state.msges[user]) {
      Vue.set(state.msges, user, []);
    }
    state.msges[user].push(msg);
    if (msg.fromUserId === state.currentUser.userid) return;
    if (!msg.speech) return;
    const voiceMsg = new SpeechSynthesisUtterance(msg.speech);
    voiceMsg.voice = window.speechSynthesis.getVoices()[0];
    window.speechSynthesis.speak(voiceMsg);
  },
  setCurrentUserCountry(state, val) {
    state.currentUserCountry = val;
  },
  setCurrentUser(state, val) {
    state.currentUser = val;
  },

  setCompareGlobal(state, val) {
    state.actions.compareGlobal = val;
  },

  setDrillByIndustry(state, val) {
    state.actions.drillByIndustry = val;
  },

  setHistorical(state, val) {
    state.actions.historical = val;
  },

  setMakePrediction(state, val) {
    state.actions.makePrediction = val;
  },

  setFinancialReports(state, val) {
    if (val) {
      state.dataSourceSelections.employeesReacted = false;
      state.dataSourceSelections.recruitmentPosting = false;
      state.dataSourceSelections.newsObserved = false;
    }

    state.dataSourceSelections.financialReports = val;
  },

  setEmployeesReacted(state, val) {
    if (val) {
      state.dataSourceSelections.financialReports = false;
      state.dataSourceSelections.recruitmentPosting = false;
      state.dataSourceSelections.newsObserved = false;
    }

    state.dataSourceSelections.employeesReacted = val;
  },

  setRecruitmentPosting(state, val) {
    if (val) {
      state.dataSourceSelections.financialReports = false;
      state.dataSourceSelections.employeesReacted = false;
      state.dataSourceSelections.newsObserved = false;
    }

    state.dataSourceSelections.recruitmentPosting = val;
  },

  setNewsObserved(state, val) {
    if (val) {
      state.dataSourceSelections.employeesReacted = false;
      state.dataSourceSelections.recruitmentPosting = false;
      state.dataSourceSelections.financialReports = false;
    }

    state.dataSourceSelections.newsObserved = val;
  },
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js